import { render, staticRenderFns } from "./BankAccountSelector.vue?vue&type=template&id=5e484ac4&scoped=true&"
import script from "./BankAccountSelector.vue?vue&type=script&lang=js&"
export * from "./BankAccountSelector.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountSelector.vue?vue&type=style&index=0&id=5e484ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e484ac4",
  null
  
)

export default component.exports